module.exports = __webpack_public_path__ + "static/flags/CN-110436c423a1c7db6d9ca64a0eaf8ca5.gif";